__turbopack_context__.v({
  "input": "input-module-scss-module__UXu1qq__input",
});
